import { useRef } from "react";
import styles from "./SubscriptionSection.module.css";
import arrowRightBlue from "../assets/arrowRightBlue.png";
import arrowRight from "../assets/arrowRight.png";
import { useModal } from "./ModalProvider";
import SubscriptionForm from "./SubscriptionForm";
import Bubble from "./Bubble";

type Props = {
  stickyBanner?: boolean;
  /**
   * Optional override text for the banner.
   * Default: "Ne rate plus aucun événement à Québec — abonne-toi."
   */
  bannerText?: string;
};

export default function SubscriptionSection({
  stickyBanner = false,
  bannerText = "Ne rate plus aucun événement à Québec — abonne-toi gratuitement!"
}: Props) {
  const { show } = useModal();
  const bannerRef = useRef<HTMLDivElement | null>(null);

  const openSubscriptionModal = () => {
    show(<SubscriptionForm />, { backgroundColor: "#013da5", textColor: "#ecf4f6" });
  };

  if (stickyBanner) {
    return (
      <>
        <div
          ref={bannerRef}
          className={styles.banner}
          role="region"
          aria-label="Infolettre alentours"
        >
          <div className={styles.bannerContent}>
            <span className={styles.bannerText}>{bannerText}</span>
            <div className={styles.bannerActions}>
              <button
                type="button"
                onClick={openSubscriptionModal}
                className={styles.bannerCta}
              >
                Je m’abonne
                <img className={styles.arrowBlue} src={arrowRightBlue} alt="" width="40" height="13" />
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  // Default (non-sticky) section you already have
  return (
    <div className={styles.parent}>
      <div id="subscribe" className={styles.container}>
        <h2>Ta ville a plein d’événements à offrir</h2>

        <div className={styles.text}>
          <h1>Tu cherches quoi faire à Québec?</h1>

          <p>
            Tanné.e de rester chez vous? <br />
            Dis-nous ce que tu aimes, on t’envoie les meilleurs <br />
            événements sur mesure chaque semaine ! <br />
          </p>
        </div>
      </div>

      <div className={styles.flexRight}>
        <button type="button" onClick={openSubscriptionModal}>
          Je m&apos;abonne!
          <img className={styles.arrow} src={arrowRight} alt="je m'abonne" width="40" height="13" />
        </button>

        <Bubble threshold={310}>
          <div className={styles.infolettreBox} onClick={openSubscriptionModal}>
            alentours <br /> a maintenant une <br />
            <strong>infolettre</strong>!
          </div>
        </Bubble>
      </div>
    </div>
  );
}
